import createHistory from 'history/createBrowserHistory'
export default createHistory()


// WEBPACK FOOTER //
// ./resources/assets/js/actions/history.js